



import { Vue, Component } from "vue-property-decorator";

import AdminCustomerIdList from "@/components/admin/adminCustomerIdList.vue";

@Component({
  name: "AdminCustomerIds",
  components: {
    AdminCustomerIdList,
  },
})
export default class AdminCustomerIds extends Vue {}
